<template>
	<div class="cuadro">
		<div class="popContenidoInterno">

			<h1 class="titleCuadro">
				Do you need additional information?
			</h1>
			<h2 class="subtitleCuadro">
				Speak with one of our knowledgeable account executives
			</h2>
			<!-- <span>contact us</span> -->
			<router-link tag="span" :to="{name: 'contact'}"><a>contact us</a></router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PopEachService',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import url("../assets/less/soloVariables.less");


.cuadro {
	padding: 50px 0px;
	//border: 1px solid green;
	width: 30%;
	@media @tablet {
		width: 65%;
		padding: 30px 40px;
	}
	@media @mobile {
		width: 85%;
		padding: 9px 0px;
	}
	.popContenidoInterno {
		margin: auto;
		min-width: 300px;
		min-height: 300px;
		text-align: center;
		padding: 20px 0px;
		color: white;
		background-color: @color_Principal_Logo;

		display: flex;
		flex-flow: column;
		align-items: center;

		.titleCuadro {
			font-size: 1.9em;
			font-weight: 500;
			width: 88%;

			@media @desktop-xl{
				width: 90%;
			}

			@media @desktop{
				width: 95%;
			}

			@media @tablet {
				padding-top: 10px;
				width: 80%;
			}
			@media @mobile {
				width: 70%;
			}
		}
		.subtitleCuadro {
			font-size: 1.3em;
			font-weight: 200;
			padding-bottom: 20px;
			text-align: center;

			@media @desktop-xl{
				width: 90%;
			}

			@media @desktop{
				width: 95%;
			}

			@media @tablet {
				font-size: 1.5em;
				width: 70%;
			}
			@media @mobile {
				width: 70%;
			}
		}
	}
	span {
		a{
			color: white;
		}
		text-transform: uppercase;
		padding: 15px 25px;
		border-radius: 5px;
		cursor: pointer;
		background-color: @color_Secundario_Logo;
		font-size: 0.9em;
		&:hover {
			background-color: lighten(@color_Secundario_Logo, 10);
		}
		@media @mobile{
			padding: 15px 35px;
			width: 40%;
		}
	}
}
</style>
